import { CSSProperties } from 'react';
import { DataPackageV2Component } from '@vivli/shared/features/data-package/components';
import { IExternalLinkOptions } from '@vivli/shared/infrastructure/interface';
import { StudyExternalLinksComponent } from '@vivli/shared/components';
import { StudyMetadataPackageFilesConstant } from '@vivli/shared/infrastructure/constants';
import { IDataPackage, IDataPackageFileDescriptor } from '@vivli/shared/features/data-package/infrastructure/interface';

interface DocumentsDataPackageFeatureProps {
    dataPackageId: string;
    secondaryDataPackageId?: string;
    availableTypes?: string[];
    onValidation?: (isValid: boolean) => void;
    allowDownload?: boolean;
    useSecureStorage?: boolean;
    showExternalLinks?: IExternalLinkOptions;
    scrollEnabled?: boolean;
    showFileWarning?: boolean;
    showVerifyButton?: boolean;
    setUploadFileName?: (fileName: string) => void;
    publiclyAvailableFiles?: IDataPackageFileDescriptor[];
    onSecondaryDataPackageUpdated?: (dataPackage: IDataPackage) => void;
}

const containerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateRows: 'auto 1fr',
    height: '100%'
};

export const DocumentsDataPackageFeature = ({
    dataPackageId,
    secondaryDataPackageId,
    availableTypes,
    onValidation,
    useSecureStorage,
    showExternalLinks,
    showVerifyButton = true,
    scrollEnabled = true,
    showFileWarning,
    setUploadFileName,
    publiclyAvailableFiles,
    onSecondaryDataPackageUpdated
}: DocumentsDataPackageFeatureProps) => {
    return (
        <div style={containerStyle}>
            <DataPackageV2Component
                dataPackageId={dataPackageId}
                //secondaryDataPackageId has value when we are in Study Documents and we need File Types to show
                secondaryDataPackageId={secondaryDataPackageId}
                readOnly={false}
                allowDownload={true}
                allowUpload={true}
                allowDelete={true}
                allowSubmit={false}
                showVerifyButton={showVerifyButton}
                useSecureStorage={useSecureStorage}
                availableTypes={availableTypes || StudyMetadataPackageFilesConstant}
                hideFileType={(!availableTypes || availableTypes?.length <= 0) && !secondaryDataPackageId}
                onValidation={onValidation}
                scrollEnabled={scrollEnabled}
                showFileWarning={showFileWarning}
                onFileAdded={(file) => setUploadFileName && setUploadFileName(file.name)}
                secondaryFilesToShow={publiclyAvailableFiles}
                onSecondaryDataPackageUpdated={onSecondaryDataPackageUpdated}
            />
            {showExternalLinks && <StudyExternalLinksComponent {...showExternalLinks} />}
        </div>
    );
};
